import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText
} from '@mui/material';

function SelectField(props) {
  const { label, data, disableValue, displayEmpty, ...rest } = props;

  // const { disableValue } = props
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function setDisabled(val) {
    if (disableValue) {
      return disableValue.includes(val)
    }
  }

  return (
    <FormControl {...rest} error={isError}>
      <InputLabel>{label}</InputLabel>
      <Select {...field} {...rest} displayEmpty={displayEmpty} label={label} value={selectedValue ? selectedValue : ''} aria-label={field.name}>
        {data.map((item, index) => (
          // <div>{disableValue !== undefined ? 'défini' : 'non défini'}</div>
          // disableValue !== undefined ? disableValue.includes(item.label.toString()) : false
          <MenuItem disabled={setDisabled(item.value)} key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {_renderHelperText()}
    </FormControl>
  );
}

SelectField.defaultProps = {
  data: []
};

SelectField.propTypes = {
  data: PropTypes.array.isRequired
};

export default SelectField;
